module.exports = __webpack_public_path__ + "static/media/alert-speaker.6ed68578.png";